// Native Shopify forms remain usable without JavaScript.
if (!window.trexoCableCamBound) {
  window.trexoCableCamBound = true;
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-cc-variant]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const section = select.closest('.cable-cam');
    const price = section.querySelector('[data-cc-price]');
    const currency = price.querySelector('span');
    price.replaceChildren(document.createTextNode(option.dataset.price + ' '), currency);
    select.form.querySelector('[name="quantity"]').value = option.dataset.min;
  });
}
